import styled from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";

import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

const { carbon } = colorsPalettes;
export const WidgetsOverviewWrapper = styled(FlexColumn)`
    gap: 12px;
    margin-top: 24px;
`;
export const CompareOverviewWrapper = styled(FlexColumn)`
    gap: 24px;
`;
export const Title = styled.div`
    ${setFontVariant("h5", carbon[500])};
`;
export const Container = styled(FlexColumn)`
    gap: 24px;
    box-sizing: border-box;
    width: 100%;
`;

export const Widget = styled.div`
    width: 100%;
    flex: 1;
    min-width: 428px;
`;
export const Row = styled(FlexRow)`
    gap: 24px;
    justify-content: space-between;
    min-width: 880px;
    align-items: stretch;
`;
